var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('text-form-group',{attrs:{"value":_vm.value.factor,"name":"factor","label":"Factor","error":(_vm.errors.factor || [])[0]},on:{"input":function($event){return _vm.input('factor', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }